import { images } from '../../../Constants/ImageUrls';

export const DiaperBannerImages = {
  mobileImage: images.mobileClothDiaper,
  desktopImage: images.desktopClothDiaper,
  readyToChoicemWeb: '/images/mwebreadytochoice.png',
  readyToChoicemDesktop: '/images/desktopreadytomakechoice.png',
};

export const readyToChoiceGif = {
  readyToChoicemWeb: images.rtcMobile,
  readyToChoicemDesktop: images.rtcDesktop,
  mobileImage: images.diapernewmwebtopBanner,
  desktopImage: images.diapernewDwebTopBanner,
};

export const certificatesData = [
  {
    image: images.trustDoctorRecommend,
    name: 'Doctor Recommended',
  },
  {
    image: images.trustOeko,
    name: 'Oeko-Tex Certified',
  },
  {
    image: images.trustLeakProof,
    name: '5 hour leak proof',
  },
  {
    image: images.trustGoodness,
    name: 'Goodness of Cloth',
  },
];
export const certificatesDataTuesdaySale = [
  {
    image: images.highQuality,
    name: 'High Quality Assured',
  },
  {
    image: images.bestValue,
    name: 'Best Value Always',
  },
  {
    image: images.easyReturn,
    name: 'Easy Returns & Refunds',
  },
  {
    image: images.codAvailable,
    name: 'COD Available',
  },
];

export const FAQDataClothDiaper = [
  {
    title: 'How are cloth diapers different from disposable ones?',
    text: 'Cloth diapers can be reused after a wash, they are size adjustable to fit your baby from 3 months to 3 years and they come in multiple cute prints.',
  },
  {
    title: 'Is it comfortable in summertime? ',
    text: 'Yes, Mylo Baby Cloth diapers are made of cotton and are soft & skin-friendly, which keeps rashes away too. 100% comfortable even during summer season.',
  },
  // {
  //     title: "How much pee can cloth diaper soak?",
  //     text: "The Insert pads of our Cloth Diapers have up to 5 hours of absorbency.",
  // },
  {
    title: 'How many cloth diapers do you need in a day?',
    text: "You need approximately 3 Diapers per day (considering you don't have additional insert pads). This is taking into account that an average baby pees every 2 hours and Mylo Baby Cloth Diapers take 4-6 hours to dry.",
  },
  // {
  //     title: "Can you use cloth diaper overnight or for heavy wetters?",
  //     text: "Although our cloth diapers don’t leak for up to 5 hours, we do not suggest them to be worn by a heavy wetter at night.  If using at night, we recommend the Insert Pads to be changed every 3-4 hours.",
  // },
  {
    title: 'When washing, do you need to wash the outer covering also?',
    text: 'Yes, if spoiled, it should be washed.',
  },
  {
    title: 'How fast does it dry?',
    text: "We can't define the exact number of hours as the climatic condition of every place is different. Also, it would vary depending on whether it’s being machine washed or hand washed. Machine wash with spin dry on low heat will dry quickly.",
  },
];
export const FAQLactomama = [
  {
    title: 'How quickly will I see results after using Lactomama?',
    text: 'Many moms notice a difference in milk supply within 7 days of regular use.',
  },
  {
    title: 'Is Lactomama safe for me and my baby?',
    text: 'Yes, Lactomama is made with safe, natural ingredients and is designed specifically for breastfeeding moms.',
  },

  {
    title: 'How do I use Lactomama?',
    text: 'Lactomama is easy to use. Just mix 2 scoops into a glass of milk, water or smoothie daily.',
  },
  {
    title: 'How long should I take Lactomama?',
    text: 'It is recommended to continue for at least 6 months for best breastfeeding and postpartum recovery support.',
  },
  {
    title: 'When can I start taking Lactomama after delivery?',
    text: 'You can begin taking Lactomama 4 days after birth.',
  },
  {
    title: 'Can Mylo Lactomama be consumed while recovering from a C-section?',
    text: 'Absolutely! Its ingredients like Moringa and Panchatrina Mool aid postpartum recovery and enhance lactation.',
  },
];
export const FAQStretchMarks = [
  {
    title: 'Is Stretch Marks Kit safe to use in Pregnancy & Breastfeeding?',
    text: 'Yes, our Stretch Marks Kit is absolutely safe to apply in Pregnancy & Breastfeeding. In fact, for best results, we recommend you start using it from the first month of pregnancy.',
  },
  {
    title: 'On which areas can I apply Stretch Marks Kit?',
    text: 'You can apply it on any body part affected by stretch marks - Be it belly, arms, chest, lower back, thighs or hips.',
  },

  {
    title: 'How long does Stretch Mark Kit take to show its effect?',
    text: 'Our Stretch Marks Kit is powered by Striover which is clinically proven to show visible results in 28 Days. However, it needs to be applied consistently for a minimum of 3 months for significant results.',
  },

  {
    title: 'When to start using Stretch Marks Kit?',
    text: 'For best results, we recommend you to start using it from the first month of pregnancy.',
  },
  {
    title: 'What’s the correct way to use Stretch Marks Kit?',
    text: 'Apply Stretch Marks Cream during the day and Stretch Marks Oil at night. Do so consistently for 3 months.',
  },
  {
    title: 'Can Stretch Marks Kit erase old stretch marks as well?',
    text: ' Yes, it erases both old and new stretch marks',
  },
  {
    title: 'RETURN POLICY',
    text: '<ul><li>If you receive a damaged, defective, or wrong item, you are eligible for a full refund.</li><li>Once the product is opened, it cannot be returned.</li><li>If there are any quality issues – returns and/or refunds are handled on a case-to-case basis. To request for a return and/or refund, go to ‘My Orders & Bookings’ and click on the ‘Return Order’ button. Alternatively, you can reach out to Mylo Customer Care on 08047190745 during business hours*</li><ul>',
  },
];
export const happyTuesdayFaqs = [
  {
    title: 'Is the offer applicable on all Mylo products?',
    text: 'Yes, you can avail the offer on all product ranges.',
  },
  {
    title: 'Is there a minimum purchase amount to avail the offer?',
    text: "Yes, you'll need to add products worth Rs.999 to avail the offer.",
  },
  {
    title: 'Do I need to apply some coupon code?',
    text: 'No, the coupon will be automatically applied at the checkout page.',
  },
  {
    title: 'Can I club the offer with some other offer?',
    text: 'No, only one coupon is applicable per transaction.',
  },
];

export const joyfulDaysFaqs = [
  {
    title: 'What is the duration of the Mylo Joyful Sale? ',
    text: 'The sale is live for 4 days only. Don’t miss out on these amazing offers! ',
  },
  {
    title: 'How to Claim Cashback?',
    text: 'You need to simply download the Mylo application and login from your registered mobile number.',
  },
  {
    title: 'Are your products made with natural ingredients? ',
    text: 'Yes, all Mylo products are crafted with pure and natural ingredients to ensure safety and quality for both moms and babies. ',
  },
  {
    title: 'Can I return or exchange items purchased during the sale?',
    text: 'Absolutely! Our standard return and exchange policy applies.',
  },
  {
    title: 'Is there free shipping during the sale?',
    text: 'Yes, we offer free shipping on orders above Rs 499. Check your cart to see if you qualify for this benefit. ',
  },
];

export const joyfulDaysOffers = [
  {
    term_id: 7750,
    term: 'Get 20% Off',
    parent_id: 4963,
    is_functional: 1,
    name: 'Mylo Joyful Days | Win Flat Rs 120 Cashback',
    icon: null,
    description: 'Extra 15% Off + Flat Rs 120 Cashback | Min Order: 799',
    meta_description: 'Extra 15% Off + Flat Rs 120 Cashback | Min Order: 799',
    hindi_description: 'Mylo JoyFull Days Special',
    hindi_meta_description: '15% Off upto Rs 80 + Rs 100 Cashback',
    tag_image: '',
    tag_image_hindi: '',
    color: '#000000',
    banner_image: '',
    banner_image_hindi: '',
    offer_id: 699,
    name_hi: '15% Off + Rs 120 Cashback',
    value_type: '2',
    value: null,
    value_json: '{"percentage":15,"action":"price"}',
    max_discount_price: 80,
    min_num_limit: 1,
    max_num_limit: 1000,
    validity_type: '3',
    validity: 30,
    repeat_count: 100,
    payment_mode: '0',
    cart_min_amount: 999,
    cart_max_amount: 100000,
    start_date: '2025-01-23T17:00:16.000Z',
    end_date: '2034-01-19T18:00:20.000Z',
    stage: 'mother,pregnant,ttc',
    level: '1',
    tnc: '',
    tnc_hi: '',
    not_applicable_text: '',
    not_applicable_text_hi: '',
    priority: 3,
    for_all_product: 1,
    platform: '2',
    deeplink: null,
    deeplink_value: '',
    web_offer_url: '',
    category_banner: '',
    category_banner_hindi: '',
    product_id: 211,
    web_url: null,
    mylo_cash_reward: 100,
    product_ids:
      '211,214,280,283,284,286,352,381,404,450,451,456,504,505,506,507,508,541,543,602,603,604,605,610,611,612,614,616,625,699,707,728,729,730,731,732,748,749,750,751,758,766,767,768,769,770,771,784,788,793,794,800,801,816,820,821,826,847,852,853,862,908,964,967,969,976,977,979,1006,1009,1012,1014,1018,1019,1026,1027,1028,1034,1042,1044,1045,1047,1048,1054,1055,1089,1090,1092,1093,1094,1096,1097,1122,1127,1128,1131,1216,1217,1218,1219,1237,1242,1243,1244,1267,1288,1289,1290,1315,1363,1367,1368,1370,1375,1436,1673,1674,1675,1677,1678,1702,1703,1704,1705,1706,1707,1708,1709,1710,1774,1780,1782,1789,1804,1828,1829,1830,1833,1834,1835,1948,1949,1950,1961,2001,2002,2006,2007,2008,2009,2019,2020,2021,2023,2024,2025,2026,2027,2028,2029,2030,2031,2032,2035,2036,2037,2039,2040,2041,2042,2049,2050,2061,2062,2063,2064,2065,2066,2067,2068,2071,2072,2073,2074,2075,2076,2077,2078,2079,2080,2081,2082,2168,2181,2202,2230,2231,2238,2239,2252,2253,2254,2255,2257,2258,2259,2292,2294,2295,2296,2298,2306,2308,2309,2310,2312,2313,2322,2342,2343,2370,2371,2372,2373,2374,2375,2376,2378,2379,2380,2381,2396,2397,2399,2400,2401,2419,2421,2422,2426,2434,2588,2608,2609,2610,2611,2612,2613,2619,2620,2621,2622,2623,2628,2629,2630,2631,2632,2683,2840,2841,2842,2843,2844,2845,2846,2847,2848,2849,2851,2877,2878,2879,2880,2890,2891,2892,2893,2974,2986,2987,2989,2994,3119,3132,3133,3143,3145,3159,3162,3163,3204,3214,3253,3269,3402,3403,3404,3407,3408,3419,3421,3422,3433,3434,3435,3455,3465,3466,3482,3483,3484,3485,3486,3496,3497,3498,3505,3506,3507,3511,3517,3518,3523,3525,3526,3528,3529,3530,3531,3532,3533,3534,3535,3536,3537,3545,3546,3555,3567,3568,3569,3596,3600,3662,3663,3664,3665,3666,3673,3676,3677,3679,3680,3687,3688,3689,3703,3704,3730,3744,3745,3746,3747,3775,3776,3777,3778,3829,3839,3840,3841,3842,3843,3853,3854,3855,3857,3858,3859,3860,3861,3862,3863,3864,3865,3866,3876,3877,3878,3888,3894,3895,3896,3907,3909,3910,3913,3914,3915,3916,3917,3920,3921,3928,3929,3930,3931,3932,1827',
    offer_heading: 'WELCOME OFFER',
    globalCoupon: true,
    coupon_id: 39484545,
    code: 'CASHBACK120',
    expire_date: '2034-01-19T18:00:20.000Z',
    active: false,
    canApply: true,
    cta: { text: '', web_offer_url: 'https://mylofamily.com/' },
    nonApplicableStrip: {},
    isApplicable: true,
    conditions: { en: 'Offer is Applicable on Order value of Rs 999' },
  },
  {
    term_id: 7743,
    term: 'Get 20% Off- Lactomama',
    parent_id: 4963,
    is_functional: 1,
    name: 'Get 20% Off on Lactomama + Flat Rs. 50 Cashback',
    icon: 'https://images.myloapp.in/tags/173400372666.webp',
    description:
      'Discount upto Rs. 80 + Rs. 50 Cashback (only on prepaid orders)',
    meta_description:
      'Discount upto Rs. 80 + Rs. 50 Cashback (only on prepaid orders)',
    hindi_description: 'एक्स्ट्रा 20% ऑफ (केवल प्रीपेड ऑर्डर पर)',
    hindi_meta_description: 'मैक्स डिस्काउंट ₹80 तक (केवल प्रीपेड ऑर्डर पर)',
    tag_image: 'https://images.myloapp.in/tags/173400372653.webp',
    tag_image_hindi: '',
    color: '#000000',
    banner_image: '',
    banner_image_hindi: '',
    offer_id: 694,
    name_hi: 'Save 20% on Lactomama',
    value_type: '2',
    value: null,
    value_json: '{"percentage":20,"action":"price"}',
    max_discount_price: 80,
    min_num_limit: 1,
    max_num_limit: 100,
    validity_type: '3',
    validity: 60,
    repeat_count: 100,
    payment_mode: '2',
    cart_min_amount: 10,
    cart_max_amount: 10000,
    start_date: '2024-12-09T18:00:40.000Z',
    end_date: '2036-12-10T20:00:43.000Z',
    stage: 'mother,pregnant,ttc',
    level: '1',
    tnc: 'https://images.myloapp.in/tnc/6947743_1734008872_591507935_tnc.html',
    tnc_hi:
      'https://images.myloapp.in/tnc/6947743_1734008873_942804198_tnc_hi.html',
    not_applicable_text: '',
    not_applicable_text_hi: '',
    priority: 50,
    for_all_product: 0,
    platform: '0',
    deeplink: null,
    deeplink_value: '',
    web_offer_url: '',
    category_banner: '',
    category_banner_hindi: '',
    product_id: 3878,
    web_url: null,
    mylo_cash_reward: 0,
    product_ids: '3878,3928,3929',
    offer_heading: 'WELCOME OFFER',
    globalCoupon: true,
    coupon_id: 38408088,
    code: 'MAMA20',
    expire_date: '2036-12-10T20:00:43.000Z',
    active: false,
    canApply: true,
    cta: { text: '', web_offer_url: 'https://mylofamily.com/' },
    nonApplicableStrip: {},
    isApplicable: true,
    conditions: { en: 'Offer is Not Applicable on this Product' },
  },
  {
    term_id: 7741,
    term: 'Lactomama_15',
    parent_id: 4963,
    is_functional: 1,
    name: 'Get 15% Off on Lactomama + Flat Rs. 50 Cashback',
    icon: 'https://images.myloapp.in/tags/173089990352.webp',
    description: 'Discount upto Rs 50 + Rs. 50 Cashback',
    meta_description: 'Discount upto Rs 50 + Rs. 50 Cashback',
    hindi_description: 'एक्स्ट्रा 15% ऑफ',
    hindi_meta_description: 'Rs. 50 रुपये तक',
    tag_image: 'https://images.myloapp.in/tags/173089990429.webp',
    tag_image_hindi: 'https://images.myloapp.in/tags/173089990576.webp',
    color: '#000000',
    banner_image: '',
    banner_image_hindi: '',
    offer_id: 692,
    name_hi: 'Get 15% Off on Lactomama',
    value_type: '2',
    value: null,
    value_json: '{"percentage":15,"action":"price"}',
    max_discount_price: 50,
    min_num_limit: 1,
    max_num_limit: 100000,
    validity_type: '3',
    validity: 60,
    repeat_count: 100,
    payment_mode: '0',
    cart_min_amount: 100,
    cart_max_amount: 100000,
    start_date: '2024-11-05T19:00:18.000Z',
    end_date: '2030-11-05T19:00:21.000Z',
    stage: 'mother,pregnant,ttc',
    level: '1',
    tnc: 'https://images.myloapp.in/tnc/6927741_tnc.html',
    tnc_hi:
      'https://images.myloapp.in/tnc/7741_1730900317_1217551181_tnc_hi.html',
    not_applicable_text: '',
    not_applicable_text_hi: '',
    priority: 80,
    for_all_product: 0,
    platform: '0',
    deeplink: null,
    deeplink_value: '',
    web_offer_url: '',
    category_banner: '',
    category_banner_hindi: '',
    product_id: 3878,
    web_url: null,
    mylo_cash_reward: 0,
    product_ids: '3878,3928,3929',
    offer_heading: 'WELCOME OFFER',
    globalCoupon: true,
    coupon_id: 37079991,
    code: 'BOOSTMILK',
    expire_date: '2030-11-05T19:00:21.000Z',
    active: false,
    canApply: true,
    cta: { text: '', web_offer_url: 'https://mylofamily.com/' },
    nonApplicableStrip: {},
    isApplicable: true,
    conditions: { en: 'Offer is Not Applicable on this Product' },
  },
  // {
  //     term_id: 7749,
  //     term: "B2G1 Cloth Diaper And Diaper Pants",
  //     parent_id: 4963,
  //     is_functional: 1,
  //     name: "B2G1 Free- Diaper Pants Deal",
  //     icon: null,
  //     description: "Buy 2 Cloth diapers and Get 1 Diaper pants Free + 100 Cashback",
  //     meta_description: "B2G1 2 Cloth Diaper +  1 Diaper Pants",
  //     hindi_description: "B2G1 2 Cloth Diaper +  1 Diaper Pants",
  //     hindi_meta_description: "B2G1 2 Cloth Diaper +  1 Diaper Pants",
  //     tag_image: "",
  //     tag_image_hindi: "",
  //     color: "#000000",
  //     banner_image: "",
  //     banner_image_hindi: "",
  //     offer_id: 698,
  //     name_hi: "B2G1 Free - Special Diaper deal",
  //     value_type: "1",
  //     value: null,
  //     value_json: '{"buy":2,"free":1,"action":"price"}',
  //     max_discount_price: 214214,
  //     min_num_limit: 3,
  //     max_num_limit: 324,
  //     validity_type: "3",
  //     validity: 1000,
  //     repeat_count: 20,
  //     payment_mode: "0",
  //     cart_min_amount: 300,
  //     cart_max_amount: 99999,
  //     start_date: "2020-01-15T13:14:06.000Z",
  //     end_date: "2027-06-11T13:14:13.000Z",
  //     stage: "mother,pregnant,ttc",
  //     level: "1",
  //     tnc: "",
  //     tnc_hi: "",
  //     not_applicable_text: "",
  //     not_applicable_text_hi: "",
  //     priority: 51,
  //     for_all_product: 0,
  //     platform: "2",
  //     deeplink: 182,
  //     deeplink_value: "cloth_diaper_new_printed",
  //     web_offer_url: "https://mylofamily.com/category/Day-And-Night-Diapers",
  //     category_banner: "",
  //     category_banner_hindi: "",
  //     product_id: 504,
  //     web_url: null,
  //     mylo_cash_reward: 0,
  //     product_ids:
  //         "504,505,506,507,508,966,967,968,969,970,2151,2149,2153,3271,3272,3273,3274,3275,3276,3277,2178,1694,1697,1691,3912,2378,2379,2380,2381,3917",
  //     offer_heading: "WELCOME OFFER",
  //     globalCoupon: true,
  //     coupon_id: 39369326,
  //     code: "DAYANDNIGHTDEAL",
  //     expire_date: "2027-06-11T13:14:13.000Z",
  //     active: false,
  //     canApply: true,
  //     cta: {
  //         text: "View Products",
  //         web_offer_url:
  //             "https://mylofamily.com/category/Day-And-Night-Diapers",
  //     },
  //     nonApplicableStrip: {},
  //     isApplicable: true,
  //     conditions: { en: "Offer is Not Applicable on this Product" },
  // },
  // {
  //     term_id: 5856,
  //     term: "B2G1 Diaper - Web",
  //     parent_id: 4963,
  //     is_functional: 1,
  //     name: "B2G1 Free - Special Diaper deal",
  //     icon: "https://images.myloapp.in/tags/173072341222.webp",
  //     description: "Add 3 diapers to cart, pay for 2 + 100 Cashback",
  //     meta_description: "B2G1 Free - Choose any design",
  //     hindi_description: "Add 3 diapers to cart, pay for 2",
  //     hindi_meta_description: "B2G1 Free - Choose any design",
  //     tag_image: "https://images.myloapp.in/tags/173072341391.webp",
  //     tag_image_hindi: "https://images.myloapp.in/tags/173072341473.webp",
  //     color: "#000000",
  //     banner_image: "",
  //     banner_image_hindi: "",
  //     offer_id: 406,
  //     name_hi: "B2G1 Free - Special Diaper deal",
  //     value_type: "1",
  //     value: null,
  //     value_json: '{"buy":2,"free":1,"action":"price"}',
  //     max_discount_price: 214214,
  //     min_num_limit: 3,
  //     max_num_limit: 324,
  //     validity_type: "3",
  //     validity: 1000,
  //     repeat_count: 20,
  //     payment_mode: "0",
  //     cart_min_amount: 300,
  //     cart_max_amount: 99999,
  //     start_date: "2020-01-15T13:14:06.000Z",
  //     end_date: "2025-06-11T13:14:13.000Z",
  //     stage: "mother,pregnant,ttc",
  //     level: "1",
  //     tnc: "",
  //     tnc_hi: "",
  //     not_applicable_text: "",
  //     not_applicable_text_hi: "",
  //     priority: 51,
  //     for_all_product: 0,
  //     platform: "0",
  //     deeplink: 182,
  //     deeplink_value: "cloth_diaper_new_printed",
  //     web_offer_url:
  //         "https://mylofamily.com/category/reusable-cloth-diapers-5433",
  //     category_banner: "",
  //     category_banner_hindi: "",
  //     product_id: 504,
  //     web_url: null,
  //     mylo_cash_reward: 0,
  //     product_ids:
  //         "504,505,506,507,508,966,967,968,969,970,2151,2149,2153,3271,3272,3273,3274,3275,3276,3277,2178,1694,1697,1691",
  //     offer_heading: "WELCOME OFFER",
  //     globalCoupon: true,
  //     coupon_id: 3778687,
  //     code: "DIAPERDEAL",
  //     expire_date: "2025-06-11T13:14:13.000Z",
  //     active: false,
  //     canApply: true,
  //     cta: {
  //         text: "View Products",
  //         web_offer_url:
  //             "https://mylofamily.com/category/reusable-cloth-diapers-5433",
  //     },
  //     nonApplicableStrip: {},
  //     isApplicable: true,
  //     conditions: { en: "Offer is Not Applicable on this Product" },
  // },
  {
    term_id: 6013,
    term: 'GET 10% OFF',
    parent_id: 4963,
    is_functional: 1,
    name: 'GET 10% Off + Flat Rs. 70 Cashback',
    icon: 'https://images.myloapp.in/tags/172413369530.webp',
    description: 'Extra 10% Off on your first Mylo Order + Rs. 70 Cashback',
    meta_description:
      'Extra 10% Off on your first Mylo Order + Rs. 70 Cashback',
    hindi_description: 'Extra 10% Off on your first Mylo Order',
    hindi_meta_description: 'EXTRA 10% Off',
    tag_image: 'https://images.myloapp.in/tags/172413369622.webp',
    tag_image_hindi: 'https://images.myloapp.in/tags/172413369698.webp',
    color: '#000000',
    banner_image: '',
    banner_image_hindi: '',
    offer_id: 427,
    name_hi: 'GET 10% OFF',
    value_type: '2',
    value: null,
    value_json: '{"percentage":10,"action":"price"}',
    max_discount_price: 1500,
    min_num_limit: 1,
    max_num_limit: 999,
    validity_type: '3',
    validity: 30,
    repeat_count: 6,
    payment_mode: '0',
    cart_min_amount: 449,
    cart_max_amount: 99999,
    start_date: '2022-04-21T14:13:03.000Z',
    end_date: '2028-09-28T06:00:00.000Z',
    stage: 'mother,pregnant,ttc',
    level: '3',
    tnc: '',
    tnc_hi: '',
    not_applicable_text: '',
    not_applicable_text_hi: '',
    priority: 30,
    for_all_product: 0,
    platform: '2',
    deeplink: null,
    deeplink_value: '',
    web_offer_url: '',
    category_banner: '',
    category_banner_hindi: '',
    product_id: 108,
    web_url: null,
    mylo_cash_reward: 0,
    product_ids:
      '108,210,211,213,214,253,258,280,281,283,284,286,349,350,351,352,353,381,382,401,404,428,450,451,456,478,485,511,512,519,520,521,524,525,526,541,542,543,602,603,625,627,699,701,707,728,729,730,731,732,743,744,745,746,747,748,749,750,751,760,763,764,765,766,767,768,769,770,771,777,778,779,780,785,788,789,790,791,792,793,794,800,816,820,821,824,826,831,832,834,842,843,844,845,846,847,852,853,854,856,857,858,860,861,862,881,897,898,907,908,963,975,976,977,978,979,1005,1006,1007,1008,1010,1012,1013,1014,1015,1016,1017,1018,1019,1020,1021,1022,1023,1024,1025,1026,1027,1028,1029,1030,1032,1033,1034,1035,1036,1037,1038,1039,1040,1041,1042,1043,1044,1045,1046,1047,1048,1049,1050,1051,1052,1053,1054,1055,1056,1057,1058,1059,1060,1061,1090,1091,1095,1115,1122,1123,1124,1125,1126,1127,1128,1129,1130,1131,1207,1216,1217,1218,1219,1237,1239,1242,1243,1244,1253,1254,1255,1256,1257,1258,1259,1260,1261,1262,1263,1264,1265,1266,1267,1288,1289,1290,1313,1314,1315,1316,1362,1363,1364,1365,1366,1367,1368,1369,1370,1372,1373,1435,1587,1625,1626,1627,1631,1642,1673,1674,1675,1676,1677,1678,1702,1703,1704,1705,1706,1708,1725,1735,1756,1767,1768,1769,1770,1771,1772,1774,1775,1776,1777,1778,1779,1780,1781,1782,1783,1784,1785,1786,1787,1788,1789,1790,1791,1792,1793,1794,1795,1796,1797,1798,1799,1800,1801,1802,1803,1804,1805,1806,1807,1808,1809,1810,1811,1812,1813,1814,1815,1816,1817,1818,1819,1820,1821,1822,1823,1824,1826,1829,1830,1831,1832,1833,1834,1841,1842,1844,1940,1941,1942,1943,1944,1945,1946,1947,1948,1949,1951,1952,1953,1954,1955,1965,2007,2008,2169,2171,2176,6,2178,2179,1092,2006,487,604,605,626,628,761,762,801,882,883,884,1700,1760,1761,964,523,825,885,1003,1031,1094,1374,1375,1707,1709,1710,1758,1773,1827,1828,1835,1836,1837,1838,1839,1840,1961,2192,2342,2343,698,1009,1960,2316,2317,2318,2319,2320,2321,1089,1096,2001,2002,2167,2168,2173,2174,2188,2189,2194,2195,2196,2197,2198,2199,2200,2201,2202,2203,2204,2205,2292,2293,2294,2295,2296,2297,2298,2306,2307,2308,2309,2310,2311,2312,2313,851,2009,2010,2011,2348,2349,2350,2437,2351,2352,758,1088,1097,1938,1939,1950,1956,1957,1958,1959,1724,2172,2175,2207,2396,2397,2398,2426,2434,2436,2438,2439,2444,2476,2477,2577,2581,2583,2584,2588,69,443,655,850,2059,2117,2118,2119,2120,2121,2122,2123,2124,2125,2126,2127,2128,2180,2181,2206,2305,2322,2425,2440,2441,2617,2621,2622,2623,2624,2625,2628,2629,2630,2663,2664,2665,2666,2668,2670,2671,2672,2673,2676,2677,2678,2681,2682,2683,2684,2685,2686,2692,2694,2695,2696,2697,2698,2699,2700,2701,2702,2706,2707,2708,2733,2734,2735,2736,2737,2738,2746,2748,2749,2751,2752,2753,2754,2755,2834,2835,2836,2837,2896,2928,2929,2950,2951,2952,2953,2954,2955,2956,2957,2958,2959,2960,2961,2966,2967,2968,2969,2986,2987,2994,2446,2610,2611,2612,2613,2711,2712,2713,2714,2721,2722,2723,2724,2725,2726,2852,2853,2854,2855,2856,2857,2858,2859,2877,2879,2880,2962,2963,2964,2965,2970,2971,2972,2973,2974,2975,2976,2977,2978,2979,2980,2981,2989,3008,3039,3056,3057,3058,3059,3060,3061,3062,3063,3064,3065,3066,3067,3068,3069,3070,3071,3072,3073,3119,3132,3133,3143,3144,3145,3147,3148,3159,3162,3164,3187,3252,3253,3269,3499,3500,3501,3502,3503,3504,3505,3506,3507,3197,3407,2653,2876,2916,3046,3229,3230,3233,3234,3235,3236,3246,3247,3248,3249,3250,3251,3266,3267,3268,3392,3394,3395,3396,3397,3426,3427,3429,3430,3454,3525,3538,3888',
    offer_heading: 'WELCOME OFFER',
    globalCoupon: true,
    coupon_id: 4512261,
    code: 'FIRST10',
    expire_date: '2028-09-28T06:00:00.000Z',
    active: false,
    canApply: true,
    cta: { text: '', web_offer_url: 'https://mylofamily.com/' },
    nonApplicableStrip: {},
    isApplicable: true,
    conditions: { en: 'Offer is Not Applicable on this Product' },
  },
];

export const JOYFULDAYS_GENERAL_ITEMS = [
  {
    itemType: 'CATEGORIES_FOR_YOU',
    section_name: 'Categories for You',
    gridSize: 3,
    priority: 1,
    viewType: 'GRID',
    cardView: true,
    items: [
      {
        itemType: 'CATEGORY',
        name: 'Lactomama',
        icon: 'https://images.myloapp.in/NestJsUploads/1728565602575-Lactation_E_-(1).webp',
        deeplink: 71,
        deeplinkValue:
          '/category/Increase-Breast-Milk-Supply-with-LactoMama-Lactation-Granules',
      },
      {
        itemType: 'CATEGORY',
        name: 'Hair Care',
        icon: 'https://images.myloapp.in/NestJsUploads/1734429324719-Category-icon_Post-PregnancyHair-Care_E.webp',
        deeplink: 71,
        deeplinkValue: '/category/hair-care-products-7511',
      },
      {
        itemType: 'CATEGORY',
        name: 'Maternity Ware',
        icon: 'https://images.myloapp.in/NestJsUploads/1710173166430-Maternity-Wear_en.webp',
        deeplink: 71,
        deeplinkValue: '/category/maternity-wear-products-5366',
      },
      {
        itemType: 'CATEGORY',
        name: 'Face Washes',
        icon: 'https://images.myloapp.in/NestJsUploads/1740564960950-Face_wash.webp',
        deeplink: 71,
        deeplinkValue: '/category/bath-body-products-7567',
      },
      {
        itemType: 'CATEGORY',
        name: 'Strech Marks Care',
        icon: 'https://images.myloapp.in/NestJsUploads/1710173166429-stretch-marks-care_en.webp',
        deeplink: 71,
        deeplinkValue: '/category/stretch-marks-removal-cream-7577',
      },
      {
        itemType: 'CATEGORY',
        name: 'Skin Care',
        icon: 'https://images.myloapp.in/NestJsUploads/1740564960952-Skin_care.webp',
        deeplink: 71,
        deeplinkValue: '/category/skin-care-products-7510',
      },
    ],
    generalItemBgImage:
      'https://images.myloapp.in/NestJsUploads/1725957429907-mylo-care-1.webp',
  },
  {
    itemType: 'CATEGORIES_FOR_YOU',
    section_name: 'Categories for Babies',
    gridSize: 3,
    priority: 2,
    viewType: 'GRID',
    cardView: true,
    items: [
      {
        itemType: 'CATEGORY',
        name: 'Baby Diapers',
        icon: 'https://images.myloapp.in/NestJsUploads/1710246134729-Disposable-Diapers_en.webp',
        deeplink: 71,
        deeplinkValue: '/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
      },
      {
        itemType: 'CATEGORY',
        name: 'Wipes',
        icon: 'https://images.myloapp.in/NestJsUploads/1710246227160-Baby-Wipes_en.webp',
        deeplink: 71,
        deeplinkValue: '/category/baby-wipes-5179',
      },
      {
        itemType: 'CATEGORY',
        name: 'Cloth Diapers',
        icon: 'https://images.myloapp.in/NestJsUploads/animated_webp/1728279383414-CD_B2G1_E.webp',
        deeplink: 71,
        deeplinkValue: '/category/reusable-cloth-diapers-5433',
      },
      {
        itemType: 'CATEGORY',
        name: 'Baby Clothing',
        icon: 'https://images.myloapp.in/NestJsUploads/1710246227161-Baby-Clothing_en.webp',
        deeplink: 71,
        deeplinkValue: '/category/baby-clothes-7508',
      },
      {
        itemType: 'CATEGORY',
        name: 'Baby Gear',
        icon: 'https://images.myloapp.in/NestJsUploads/1710246227161-Baby-Gear_en.webp',
        deeplink: 71,
        deeplinkValue: '/category/baby-activity-gear-7507',
      },
      {
        itemType: 'CATEGORY',
        name: 'Baby Care',
        icon: 'https://images.myloapp.in/NestJsUploads/1729682470286-Baby-Care_E.webp',
        deeplink: 71,
        deeplinkValue: '/category/baby-care-7505',
      },
    ],
    generalItemBgImage:
      'https://images.myloapp.in/NestJsUploads/1725957429905-mylo-baby-1.webp',
  },
];

export const categoryAccordionData = [
  {
    title: 'We are online on Whatsapp!',
    text: 'You will receive order updates on Whatsapp from Mylo. Get live chat support on whatsapp - feel free to message us : (8047190745). Want to try? ',
    hypText: 'Click here to chat now',
    deeplink:
      'https://wa.me/+918047190745?text=Hi, I have a question about Mylo Baby Cloth Diaper -',
  },
  {
    title: 'Get guidance on cloth diapering',
    text: 'Cloth diapers are new for many parents and we are here to help you learn how to give a perfect fit to your baby, how to wash and dry and much more. To help you start your cloth diapering journey, we will share with you Videos about how to wear and how to wash Mylo Baby Cloth Diapers. We would love to assist you personally on call should you need more assistance - Just ask for it on our whatsapp  ',
  },
  {
    title: 'Return Policy',
    contentBullet: [
      'Due to hygiene concerns, cloth diapers are non-returnable. However, if you receive a damaged or defective product, please reach out to our customer support team for assistance.',
    ],
  },
];
export const FootNoteHtmlData = `<h2 style="font-weight: 500;">
    <strong>
      Buy Mylo Baby Cloth Diaper Online&nbsp; &nbsp;&nbsp;
    </strong>
  </h2>
  <p>
    &nbsp;
    <br>
      There were times when mothers had to constantly clean up the mess their babies made because they did not have diapers available. It used to go on all day long and especially in the winters. Gone are the days, all thanks to the invention and manufacture of soft and comfortable reusable cloth diapers, both mother and baby can now breathe easily.&nbsp;
      <br>
        <br>
          </p>
        <p>
          Buy Mylo Essentials Washable &amp; Reusable diapers specially designed to make a mother's job easier, to keep baby’s skin irritation-free, and to reduce landfill waste.
        </p>
        <p>
          &nbsp;
        </p>
        <p>
          Our diapers are among the best ones. Another diapering essential that you can buy for your child is reusable cloth nappies that are easy to maintain and are worn around the house. These nappies are very cost-effective. Especially in summer and rainy weather, they are lightweight, breathable, and dry quickly.&nbsp;
        </p>
        <p>
          </p><p><br></p><h2 aria-level="2" style="color: rgb(85, 85, 85);">What are Cloth Diapers?</h2><p>Cloth diapers or reusable diapers are made of natural fabrics and can be washed and reused multiple times. Cloth diapers come in a variety of attractive designs and prints. A cloth diaper usually features a waterproof cover or outer layer and an absorbent insert or inner layer. Some inserts are attached to the cover while others fit into an outer pocket. Washable diapers are also environmentally-friendly as they don’t end up in a landfill.&nbsp;</p><h2 aria-level="2" style="color: rgb(85, 85, 85);">Why Buy Cloth Diapers Online?</h2><p>Buying cloth diapers online gives you not only the comfort of shopping from your couch but also access to all the variety there is. You can compare different reusable diapers, assess their pros and cons and make an informed decision. After all, a cloth diaper is going to be your baby’s companion.&nbsp;</p><h2 aria-level="2" style="color: rgb(85, 85, 85);">Why Buy Cloth Diapers from Mylo?</h2><p>Mylo offers India’s first OEKO-TEX-certified diapers, made with hypoallergenic fabric free from any harmful chemicals. The Mylo Baby Cloth Diapers can be washed and reused multiple times, making them eco-friendly. Mylo’s super-soft reusable diapers are suitable for babies of age 3 months to 3 years. Additionally, Mylo’s washable diapers are super absorbent and prevent rashes. What’s more, buying reusable diapers from Mylo can save you up to ₹20000 a year compared to disposable diapers as they can be reused multiple times.&nbsp;</p><h2 aria-level="2" style="color: rgb(85, 85, 85);">How to Use Washable Diapers or Cloth Diapers?</h2><ol><li data-leveltext="%1." data-font="Calibri" data-listid="2" data-list-defn-props="{&quot;335552541&quot;:0,&quot;335559684&quot;:-1,&quot;335559685&quot;:720,&quot;335559991&quot;:360,&quot;469769242&quot;:[65533,0],&quot;469777803&quot;:&quot;left&quot;,&quot;469777804&quot;:&quot;%1.&quot;,&quot;469777815&quot;:&quot;hybridMultilevel&quot;}" aria-setsize="-1" data-aria-posinset="1" data-aria-level="1">Before start using a cloth diaper, you must assemble it and adjust it according to your baby’s size.</li><li data-leveltext="%1." data-font="Calibri" data-listid="2" data-list-defn-props="{&quot;335552541&quot;:0,&quot;335559684&quot;:-1,&quot;335559685&quot;:720,&quot;335559991&quot;:360,&quot;469769242&quot;:[65533,0],&quot;469777803&quot;:&quot;left&quot;,&quot;469777804&quot;:&quot;%1.&quot;,&quot;469777815&quot;:&quot;hybridMultilevel&quot;}" aria-setsize="-1" data-aria-posinset="1" data-aria-level="1">Use the snaps or buttons along the top of the cloth diaper to adjust the waistline and the snaps below the front to make the diaper bigger or smaller.</li><li data-leveltext="%1." data-font="Calibri" data-listid="2" data-list-defn-props="{&quot;335552541&quot;:0,&quot;335559684&quot;:-1,&quot;335559685&quot;:720,&quot;335559991&quot;:360,&quot;469769242&quot;:[65533,0],&quot;469777803&quot;:&quot;left&quot;,&quot;469777804&quot;:&quot;%1.&quot;,&quot;469777815&quot;:&quot;hybridMultilevel&quot;}" aria-setsize="-1" data-aria-posinset="1" data-aria-level="1">Put the insert either in the pocket liner or place it on the top.&nbsp;</li><li data-leveltext="%1." data-font="Calibri" data-listid="2" data-list-defn-props="{&quot;335552541&quot;:0,&quot;335559684&quot;:-1,&quot;335559685&quot;:720,&quot;335559991&quot;:360,&quot;469769242&quot;:[65533,0],&quot;469777803&quot;:&quot;left&quot;,&quot;469777804&quot;:&quot;%1.&quot;,&quot;469777815&quot;:&quot;hybridMultilevel&quot;}" aria-setsize="-1" data-aria-posinset="1" data-aria-level="1">Fasten waist buttons on both sides, making sure the elastic rests on leg joints and not thighs, with no gap in between.</li></ol><p>The diaper is now ready to wear.&nbsp;&nbsp;</p><p>
        </p>
        <h2 style="font-weight: 500;">
          <strong>
            Buy Mylo Baby Cloth Diapers at Affordable Prices
          </strong>
        </h2>
        <p>
          <strong>
            &nbsp;
          </strong>
        </p>
        <p>
          At our store, you get to buy diapers at an affordable price. However, the price may vary depending on the quantity of a pack.
        </p>
        <p>
          &nbsp;&nbsp;
        </p>
        <p>
          Being a parent or guardian, you want to choose the best for your child. You might consider ours the best cloth diapers, as we make India’s first Oeko-Tex certified skin-friendly printed diapers and diaper inserts that do not irritate a baby’s sensitive skin. While buying cloth diapers online on the Mylo website, be sure of the comfort and softness.&nbsp;
        </p>
        <p>
          &nbsp;
        </p>
        <p>
          &nbsp;Want a cost-effective option? Invest in combo packs and keep a stack handy to avoid the last-minute rush.
        </p>
        <p>
          &nbsp;
        </p>
        <h2 style="font-weight: 500;">
          <strong>
            Shop Mylo Baby Cloth Diapers According to Suitability
          </strong>
        </h2>
        <p>
          &nbsp;
        </p>
        <p>
          Baby shopping is fun when done leisurely and thoughtfully. So, when you have made up your mind to buy diapers, invest in the ones that fit your family budget and lifestyle. The reusable diapers here are made of super absorbent material and are more popular because of their durability than disposable diapers. Are you still thinking? Add the goodness to your cart now!
        </p>
        <p>
          Don’t forget to check out the all-new range of&nbsp;
          <a href="https://mylofamily.com/store/category/baby-safety-products-5394" data-cke-saved-href="https://mylofamily.com/store/category/baby-safety-products-5394">
            baby safety products&nbsp;
          </a>
          and&nbsp;
          <a href="https://mylofamily.com/store/category/baby-products-5327" data-cke-saved-href="https://mylofamily.com/store/category/baby-products-5327">
            newborn baby essentials&nbsp;
          </a>
          at your favorite store
        </p>
        <p>
          .&nbsp;&nbsp;
        </p>
        <h2 style="font-weight: 500;">
          <strong>
            Cloth Diaper Price List
          </strong>
        </h2>
        <table data-tablestyle="MsoTableGrid" data-tablelook="1696" aria-rowcount="11">
          <tbody>
            <tr aria-rowindex="1">
              <td data-celllook="0">
                <p>
                  <strong>
                    <span data-contrast="auto">
                      Buy Cloth Diapers on Mylo
                    </span>
                  </strong>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
              <td data-celllook="0">
                <p>
                  <strong>
                    <span data-contrast="auto">
                      Price
                    </span>
                  </strong>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
            </tr>
            <tr aria-rowindex="2">
              <td data-celllook="0">
                <p>
                  <a href="https://mylofamily.com/essentials/free-size-reusable-cloth-diaper-with-absorbent-insert-pad-3-36-months--jungle-print-966">
                    <span data-contrast="none">
                      Mylo Adjustable Washable &amp; Reusable Cloth Diaper With Dry Feel, Absorbent Insert Pad (3M-3Y) - Jungle
                    </span>
                  </a>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
                <p>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
              <td data-celllook="0">
                <p>
                  <strong>
                    <span data-contrast="auto">
                      599
                    </span>
                  </strong>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
            </tr>
            <tr aria-rowindex="3">
              <td data-celllook="0">
                <p>
                  <a href="https://mylofamily.com/essentials/free-size-reusable-cloth-diaper-with-absorbent-insert-pad-3-36-months--pet-love-print-970">
                    <span data-contrast="none">
                      Mylo Adjustable Washable &amp; Reusable Cloth Diaper With Dry Feel, Absorbent Insert Pad (3M-3Y) - Pet Love
                    </span>
                  </a>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
                <p>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
              <td data-celllook="0">
                <p>
                  <strong>
                    <span data-contrast="auto">
                      599
                    </span>
                  </strong>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
            </tr>
            <tr aria-rowindex="4">
              <td data-celllook="0">
                <p>
                  <a href="https://mylofamily.com/essentials/free-size-reusable-cloth-diaper-with-absorbent-insert-pad-3-36-months--purple-love-print-969">
                    <span data-contrast="none">
                      Mylo Adjustable Washable &amp; Reusable Cloth Diaper With Dry Feel, Absorbent Insert Pad (3M-3Y)- Purple Love
                    </span>
                  </a>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
                <p>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
              <td data-celllook="0">
                <p>
                  <strong>
                    <span data-contrast="auto">
                      599
                    </span>
                  </strong>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
            </tr>
            <tr aria-rowindex="5">
              <td data-celllook="0">
                <p>
                  <a href="https://mylofamily.com/essentials/free-size-reusable-cloth-diaper-with-absorbent-insert-pad-3-36-months-celebration-print-968">
                    <span data-contrast="none">
                      Mylo Adjustable Washable &amp; Reusable Cloth Diaper With Dry Feel, Absorbent Insert Pad (3M-3Y) - Celebration
                    </span>
                  </a>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
                <p>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
              <td data-celllook="0">
                <p>
                  <strong>
                    <span data-contrast="auto">
                      599
                    </span>
                  </strong>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
            </tr>
            <tr aria-rowindex="6">
              <td data-celllook="0">
                <p>
                  <a href="https://mylofamily.com/essentials/free-size-reusable-cloth-diaper-with-absorbent-insert-pad-3-36-months-cherry-blossom-print-967">
                    <span data-contrast="none">
                      Mylo Adjustable Washable &amp; Reusable Cloth Diaper With Dry Feel, Absorbent Insert Pad (3M-3Y) - Cherry Blossom
                    </span>
                  </a>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
                <p>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
              <td data-celllook="0">
                <p>
                  <strong>
                    <span data-contrast="auto">
                      599
                    </span>
                  </strong>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
            </tr>
            <tr aria-rowindex="7">
              <td data-celllook="0">
                <p>
                  <a href="https://mylofamily.com/essentials/free-size-reusable-cloth-diaper-with-absorbent-insert-pad-3-36-months-floral-spring-print-508">
                    <span data-contrast="none">
                      Mylo Adjustable Washable &amp; Reusable Cloth Diaper With Dry Feel, Absorbent Insert Pad (3M-3Y) - Floral Spring
                    </span>
                  </a>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
                <p>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
              <td data-celllook="0">
                <p>
                  <strong>
                    <span data-contrast="auto">
                      599
                    </span>
                  </strong>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
            </tr>
            <tr aria-rowindex="8">
              <td data-celllook="0">
                <p>
                  <a href="https://mylofamily.com/essentials/free-size-reusable-cloth-diaper-with-absorbent-insert-pad-3-36-months-abc-print-507">
                    <span data-contrast="none">
                      Mylo Adjustable Washable &amp; Reusable Cloth Diaper With Dry Feel, Absorbent Insert Pad (3M-3Y) - ABC
                    </span>
                  </a>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
                <p>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
              <td data-celllook="0">
                <p>
                  <strong>
                    <span data-contrast="auto">
                      599
                    </span>
                  </strong>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
            </tr>
            <tr aria-rowindex="9">
              <td data-celllook="0">
                <p>
                  <a href="https://mylofamily.com/essentials/free-size-reusable-cloth-diaper-with-absorbent-insert-pad-3-36-months-heart-doodles-print-506">
                    <span data-contrast="none">
                      Mylo Adjustable Washable &amp; Reusable Cloth Diaper With Dry Feel, Absorbent Insert Pad (3M-3Y) - Heart Doodles
                    </span>
                  </a>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
                <p>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
              <td data-celllook="0">
                <p>
                  <strong>
                    <span data-contrast="auto">
                      599
                    </span>
                  </strong>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
            </tr>
            <tr aria-rowindex="10">
              <td data-celllook="0">
                <p>
                  <a href="https://mylofamily.com/essentials/free-size-reusable-cloth-diaper-with-absorbent-insert-pad-3-36-months-rainbow-print-505">
                    <span data-contrast="none">
                      Mylo Adjustable Washable &amp; Reusable Cloth Diaper With Dry Feel, Absorbent Insert Pad (3M-3Y) - Rainbow
                    </span>
                  </a>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
                <p>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
              <td data-celllook="0">
                <p>
                  <strong>
                    <span data-contrast="auto">
                      599
                    </span>
                  </strong>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
            </tr>
            <tr aria-rowindex="11">
              <td data-celllook="0">
                <p>
                  <a href="https://mylofamily.com/essentials/free-size-reusable-cloth-diaper-with-absorbent-insert-pad-3-36-months-twinkle-twinkle-print-504">
                    <span data-contrast="none">
                      Mylo Adjustable Washable &amp; Reusable Cloth Diaper With Dry Feel, Absorbent Insert Pad (3M-3Y) - Twinkle Twinkle
                    </span>
                  </a>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
                <p>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
              <td data-celllook="0">
                <p>
                  <strong>
                    <span data-contrast="auto">
                      599
                    </span>
                  </strong>
                  <span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559740&quot;:259}">
                    &nbsp;
                  </span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <h2 style="font-weight: 500;">
          &nbsp;
        </h2>
        <p>
          <strong>
            FAQs&nbsp;
          </strong>
          <strong>
            &nbsp;&nbsp;
          </strong>
        </p>
        <ol>
          <li>
            <strong>
              How many diapers does a newborn baby need?
            </strong>
          </li>
        </ol>
        <p>
          Every day, a baby uses an average of 10 to 12 diapers in the first month. That means your baby will use about 300 diapers in their first month! A 2–3-day supply of diapers is a good starting point. This amount will depend on your baby's age, your washing habits, and the type of cloth diapers you use. However, we recommend at least 36 diapers for newborns, 24 for infants, and 20 for toddlers for one month.
        </p>
        <ol start="2">
          <li>
            <strong>
              What size mylo Baby cloth diapers do I need?&nbsp;
            </strong>
          </li>
        </ol>
        <p>
          Mylo Baby cloth diaper is adjustable diapers that fit babies aged 3 months to 3 years.&nbsp;&nbsp;
        </p>
        <ol start="3">
          <li>
            <strong>
              How long can babies use cloth diapers?
            </strong>
          </li>
        </ol>
        <p>
          Cloth diapers can also be used for an average of two to three years, probably longer if you take good care of them. Cloth diapers need to be washed every two to three days to avoid odour and stain problems.
        </p>
        <ol start="4">
          <li>
            <strong>
              Do you really save money with cloth diapers?
            </strong>
          </li>
        </ol>
        <p>
          Cloth diapers are generally cheaper than disposable diapers when you add up the cost for the entire time a baby is diapered. You can save a lot more by ditching the expensive disposable wipes and using cloth wipes at home instead.
        </p>
        <ol start="5">
          <li>
            <strong>
              Do babies feel wet in cloth diapers?
            </strong>
          </li>
        </ol>
        <p>
          Yes, babies might feel wet in diapers if not changed after every 4-5 hours for an average wetting baby. 
        </p>
        <ol start="6">
            <li>
              <strong>
                Do you change a cloth diaper after every pee?
              </strong>
            </li>
          </ol>
          <p>
            No, cloth diapers are super-absorbent. You should change a cloth diaper when they start to feel heavy or after 5-6 hours.
          </p>
          <ol start="7">
            <li>
              <strong>
                When should I start cloth diapering?
              </strong>
            </li>
          </ol>
          <p>
            You can start using cloth diapers for your baby 3 month onwards and continue till 3 years.  
        </p>
          <ol start="8">
            <li>
              <strong>
                Is it okay to wash cloth diapers with other clothes?
              </strong>
            </li>
          </ol>
          <p>
            You can wash reusable diapers in your washing machine but try not to mix them with other clothes. Give a quick rinse to soiled cloth diapers before adding them to the machine.
        </p>
        <ol start="9">
            <li>
              <strong>
                Are newborn cloth nappies worth it?
            </strong>
            </li>
          </ol>
          <p>
            Absolutely, cloth diapers or washable diapers last much longer and cost much less compared to disposable diapers. Plus, they don’t contain any chemicals.
        </p><ol start="10">
            <li>
              <strong>
                Can I wash cloth diapers in cold water?  
            </strong>
            </li>
          </ol>
          <p>
            Yes, you can wash cloth diapers in cold water. However, to get rid of any stains or smell, it’s best to wash them in warm or hot water. 
        </p><ol start="11">
            <li>
              <strong>
                Are reusable diapers safe for the baby’s skin?
            </strong>
            </li>
          </ol>
          <p>
            Yes, reusable or washable diapers are absolutely safe for your baby’s skin. They are toxin-free and made with safe fabrics.</p>
        `;
